module.exports = {"title":"Nathan Schott's Portfolio","social":{"github":"https://github.com/Seavenly","linkedin":"https://www.linkedin.com/in/nathan-schott-a96037147/"},"metadata":{"keywords":"portfolio","description":"Nathan Schott's portfolio website displaying various projects."},"navigation":{"services":"/#services","portfolio":"/#portfolio","tools":"/#tools","about":"/#about","contact":"/#contact"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/config/site.yaml
// module id = 123
// module chunks = 79611799117203